import React, { memo } from "react";
import { RCCGrid } from "react-common-components";
import List from "src/components/List";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { IListIncidents } from "./interface";

const ListIncidents: React.FC<IListIncidents> = ({
	data
}) => {

	const { currentLanguage} = useTranslation();
	const {translate} = useTranslation();

    
	const colDescription = (row: any) => (
		<RCCGrid>
			{row.rib004Motivo}
		</RCCGrid>
	);

	const colDate = (row: any) => (
		<RCCGrid>
			{formatDate(row.dateCreated, currentLanguage)}
		</RCCGrid>
	);

	return(
		<List 
			data={data}
			columns={[{
				idColumn: "rib004Motivo",
				nameColumn: translate("Motivo"),
				xs: 12,
				sm: 8,
				justify: "left",
				cellRenderer: colDescription
			},{
				idColumn: "okb001Efa005Nome",
				nameColumn: translate("Data da incidência"),
				xs: 12,
				sm: 4,
				justify: "center",
				cellRenderer: colDate
			}
			]}
			
			showHeader
		/>
	);};

export default memo(ListIncidents);
